import { Component, Mixins } from '@/vue-property-decorator'
import { _CssVarManagerBase } from './cssVarManagerBase'
import {
  _CssVarManagerTemplateLarger1,
  _cssVarManagerTemplateLarger2
} from './cssVarManagerLarger'
import BaseCssVarProvide from '../../../../components/baseCssVarProvide'
export { _CssVarManagerBase }
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
@Component<CssVarCustom>({
  name: 'CssVarCustom'
})
class CssVarCustom extends Mixins<BaseCssVarProvide<_CssVarManagerBase>>(
  BaseCssVarProvide
) {
  /**
   * @deprecated 这是一个参考模板,不要直接使用它.值都是乱写的
   */
  public getCssVarManagerTemplateLarger1 = () =>
    new _CssVarManagerTemplateLarger1()

  /**
   * @deprecated 这是一个参考模板,不要直接使用它.值都是乱写的
   */
  public getCssVarManagerTemplateLarger2 = _cssVarManagerTemplateLarger2

  // 渲染入口.
  render() {
    // 不需要通过css样式设置变量,则可以不用再包一层div了
    return this.$slots.default as unknown as VueTsxSupport.JSX.Element
  }
}
/** css变量控制器 此css仅能用于修改暴露的css样式,千万不要直接写一些额外的样式,不然容易出现异常 */
export const _CssVarCustom = CssVarCustom
